module.exports = __webpack_public_path__ + "img/planta_01.2c7f8ee3.png";